<template>
  <div  style="margin-left:40px ;padding: 0; height: 60px;width:100%;">


      <el-menu
        style="overflow-x: auto;"
        _background-color="#0D5788"
        mode="horizontal"
      >

        <el-menu-item
          v-for="item in this.customGlobal.userMenuForPermission"
          :key="item.id"
          :index="item.id"  v-if="item.status==='true'">

          <el-submenu   v-if="item.detail"  :index="item.id" >
            <template slot="title"   >
            <i  :class="item.icon!==undefined?item.icon:el-icon-menu"></i>
            <span slot="title">{{ item.caption }}</span>
            </template>

            <el-menu-item   v-for="item1 in item.detail" :key="item1.id" :index="item1.id" @click.native="selectItems(item1)">
                <i  :class="item1.icon!==undefined?item1.icon:'el-icon-menu'"></i>
                <span  v-if="item1.status==='true'"   slot="title" _class="el-menu-item" >{{ item1.caption }}</span>
            </el-menu-item>

          </el-submenu>

          <el-submenu v-else  :index="item.id">
            <template slot="title"   >
            <i :class="item.icon!==undefined?item.icon:'el-icon-menu'"></i>
            <span slot="title">{{ item.caption }}</span>
            </template>
          </el-submenu>


        </el-menu-item>

      </el-menu>


  </div>
</template>

<script>
var linkTo = new Array();
export default {
  name: "IndexLeft2",
  created() {


    // linkTo = new Array();
    // for(let i1=0;i1< this.customGlobal.userMenuForPermission.length;i1++){
    //
    //   //console.info("url:"+menus[i1].detail);
    //   for(let i2=0;i2< this.customGlobal.userMenuForPermission[i1].detail.length;i2++){
    //     //console.info("url:"+this.customGlobal.userMenuForPermission[i1].detail[i2].url);
    //     linkTo.push({ url :this.customGlobal.userMenuForPermission[i1].detail[i2].url,caption:this.customGlobal.userMenuForPermission[i1].detail[i2].caption });
    //   }
    // }
    // this.linkMenu = linkTo;
  },
  data:function() {
    return {
      linkMenu: linkTo,
      menuCollapse:false,

    }
  },
  methods:{
    selectItems:function (item1){
      //console.info("url:"+item1.url+",caption:"+item1.caption)
      //this.$router.push({path:url});
      this.$emit("parent_method",{id:item1.id,caption:item1.caption,url:item1.url,vue:item1.vue});
    },
    openCloseMenu(){
      this.menuCollapse = !this.menuCollapse;
    }
  }
}
</script>

<!--<style scoped> -->
<style >



  /* 水平菜单顶层菜单样式 */
/* >符号表示直接孩子，.el-menu--horizontal>.el-submenu .el-submenu_title表示的
是类.el-menu--horizontal元素（这个是顶层菜单el-menu）下的第一层元素（sub-menu）下的标题，
这个标题是放在<i>元素的slot属性中的，从而找到了<i>元素，修改它的样式就可以了 */



/*.el-menu>.el-submenu .el-submenu__title {*/
/*  padding-left: 15px !important;*/
/*  text-align: left !important;*/
/*  font-weight: bold !important;*/
/*  font-size: 14px !important;*/
/*  !*height: 40px !important;*!*/
/*  !*line-height: 40px !important;*!*/

/*}*/



/* 水平菜单子菜单的标题（注意，标题和菜单项不一样，标题是使用<i slot="title">表示的，需要单独处理），
这里使用.el-submenu>.el-submenu_title定位到子菜单（不是菜单项） */
/*.el-menu .el-menu .el-submenu>.el-submenu__title {*/
/*  padding-left: 15px !important;*/
/*  text-align: left !important;*/

/*}*/
/* 水平菜单子菜单中的所有菜单项 */
/*.el-menu .el-menu .el-menu-item {*/
/*  !*padding-left: 15px !important;*!*/
/*  padding-left: 30px !important;*/
/*  text-align: left !important;*/
/*  !*height: 40px !important;*!*/
/*  !*line-height: 40px !important;*!*/

/*}*/
/*.el-menu--collapse .el-menu .el-submenu  .el-menu--popup {*/
/*  min-width: 160px !important;*/
/*  height: 46px!important;*/
/*  line-height: 46px!important;*/
/*}*/



</style>



// WEBPACK FOOTER //
// src/components/index/IndexLeft2.vue